module.exports = __webpack_public_path__ + "static/media/Investor-RYAN GWILLIM_1646333280778.fc08046d.vtt";